import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { IClientDeviceVm } from '../../../../api/client-device-vm.model';

/**
 * The device a user signed in or reported a problem on: model, system, app version and screen
 * (CSS size @ pixel ratio, with the physical resolution in the tooltip). Shows a dash for reports
 * sent from app versions that did not describe their device yet.
 */
@Component({
  selector: 'app-client-device',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './client-device.component.html',
  styleUrl: './client-device.component.scss',
})
export class ClientDeviceComponent {
  @Input() device?: IClientDeviceVm | null;

  get icon(): string {
    switch (this.device?.platform) {
      case 'ios':
        return 'pi pi-apple';
      case 'android':
        return 'pi pi-android';
      default:
        return 'pi pi-globe';
    }
  }

  get name(): string {
    const name = [this.device?.manufacturer, this.device?.model].filter(Boolean).join(' ');
    return name || this.device?.platform || '';
  }

  get system(): string {
    return [this.device?.operatingSystem ?? this.device?.platform, this.device?.osVersion].filter(Boolean).join(' ');
  }

  get app(): string | null {
    if (!this.device?.appVersion) {
      return null;
    }
    return this.device.appBuild ? `${this.device.appVersion} (${this.device.appBuild})` : this.device.appVersion;
  }

  get screen(): string | null {
    const device = this.device;
    if (!device?.screenWidth || !device.screenHeight) {
      return null;
    }
    return device.screenPixelRatio
      ? `${device.screenWidth}×${device.screenHeight} @${device.screenPixelRatio}x`
      : `${device.screenWidth}×${device.screenHeight}`;
  }

  get screenTooltip(): string | undefined {
    const device = this.device;
    if (!device?.physicalScreenWidth || !device.physicalScreenHeight) {
      return undefined;
    }
    return `Rozdzielczość fizyczna: ${device.physicalScreenWidth}×${device.physicalScreenHeight} px`;
  }
}
